/**
 * PC_P_01 importing the api function calls and required functions from the components.
 */

import { useState, useEffect, useRef } from 'react';
import React from 'react';
import { encode, decode } from 'base-64';
import {
    getEmployeeAddressForGrid,
    getEmployeeBankInfoForGrid,
    getEmployeeEducationInfoForGrid,
    getEmployeeCertificateInfoForGrid,
    getEmployeeDocumentInfo,
    getEmployeePassportInfoForGrid,
    getEmployeePreviousEmploymentInfoForGrid,
    getEmployeeSkillInfo,
    deleteSkillInfo,
    getEmployeeVisaInfoForGrid,
    postEmployeeDocumentInfo,
    getNotificationId,
    postUploadFile,
} from '../service/DirectorAPI';
import { NotificationTrigger } from '../utils/RegHandling';
import moment from 'moment';
import AddressDetail from './AddressForm';
import BankDetails from './BankDetailsForm';
import EducationDetail from './EducationDetailForm';
import CertificateDetails from './CertificateDetailForm';
import PassportDetail from './PassportForm';
import PreviousEmploymentDetails from './PreviousEmploymentForm';
import { SkillDetails } from './SkillsForm';
import { Upload, uploadBackend } from '../utils/Upload';
import Loader from '../StaticComponent/Loader';
import './edcss/card-structure.css';
import { connect } from 'react-redux';
import { encryptStorage } from '../constant';
import { S3 } from 'aws-sdk';
import { getS3 } from '../utils/Download.js';
import DOMPurify from 'dompurify';
/**
 *
 * PC_P_03 profile function contains the variables abe return the HTML
 */
function Profile(props) {
    /**
     * PC_P_02 Declaring the State variables,objects and array
     */

    // const attachment = useRef()
    // const VoterIdattachment = useRef();
    // const PanCardattachment = useRef();
    // const Passportattachment = useRef();
    // const AadharCardattachment = useRef();
    // const SSLCCertificateattachment = useRef();
    // const HSCCertificateattachment = useRef();
    // const UGMarksheetattachment = useRef();
    // const VaccinationCertificateattachment = useRef();
    // const Visaattachment = useRef();

    let employeeAddress = [];
    const [employeeaddress, setemployeeaddress] = useState(employeeAddress);

    let EmployeeBankDetail = [];
    const [employeebankdetail, setemployeebankdetail] = useState(EmployeeBankDetail);

    let EmployeeEducationDetail = [];
    const [employeeeducationdetail, setemployeeeducationdetail] = useState(EmployeeEducationDetail);

    let EmployeeCertificationDetail = [];
    const [employeecertificationdetail, setemployeecertificationdetail] = useState(EmployeeCertificationDetail);

    let EmployeePassportDetail = [];
    const [employeepassportdetail, setemployeepassportdetail] = useState(EmployeePassportDetail);

    let EmployeeVisaDetail = [];
    const [employeeVisadetail, setemployeeVisadetail] = useState(EmployeeVisaDetail);

    let EmployeePreviousEmpDetail = [];
    const [employeepreviousempdetail, setemployeepreviousempdetail] = useState(EmployeePreviousEmpDetail);

    let EmployeeSkillsDetail = [];
    const [employeeskilldetail, setemployeeskilldetail] = useState(EmployeeSkillsDetail);
    const [notification, setNotification] = useState([]);

    const [empid, setEmpId] = useState();
    const [addresstype, setaddressType] = useState('');

    const [addressArrLen, setaddressArrLen] = useState(-1);
    const [bankArrLen, setbankArrLen] = useState(0);
    const [educationArrLen, seteducationArrLen] = useState(0);
    const [certificationArrLen, setcertificationArrLen] = useState(0);
    const [passportArrLen, setpassportArrLen] = useState(0);
    const [previousemployArrLen, setpreviousemployArrLen] = useState(0);
    const [skillArrLen, setskillArrLenArrLen] = useState(0);

    const [bankId, setbankId] = useState();
    const [educationId, seteducationId] = useState();
    const [certificateId, setcertificateId] = useState();
    const [passportId, setpassportId] = useState();
    const [previousEmpId, setpreviousEmpId] = useState();
    const [skillId, setskillId] = useState(0);
    const [mode, setmode] = useState('');
    const [docUrl, setDocUrl] = useState('');
    const [isAddressClick, setISAddressClick] = useState(false);
    const [isBankClicked, setIsBankClicked] = useState(false);
    const [isEducationClicked, setIsEducationClicked] = useState(false);
    const [isCertificateClicked, setIsCertificateClicked] = useState(false);
    const [isPassportClicked, setIsPassportClicked] = useState(false);
    const [isPreEmployClicked, setIsPreEmployClicked] = useState(false);
    const [isSkillClicked, setIsSkillClicked] = useState(false);

    const [deletePopUp, setDeletePopUp] = useState(true);
    const [section, setSection] = useState('');
    const [isLoading, setIsLoading] = React.useState(true);
    const [attachmentValidation, setattachmentValidation] = useState('');
    const [reportstoId, setReportstoId] = useState('');
    const [imageUrl, setImageUrl] = useState('');

    let session = {
        login_id: '',
        role: '',
    };
    const [sessionData, setSession] = useState(session);
    let documentInfo = {
        VoterId: '',
        VoterDocumentId: '',
        PanCard: '',
        PanCardDocumentId: '',
        Passport: '',
        PassportDocumentId: '',
        AadharCard: '',
        AadharCardDocumentId: '',
        SSLCCertificate: '',
        SSLCCertificateDocumentId: '',
        HSCCertificate: '',
        HSCCertificateDocumentId: '',
        UGMarksheet: '',
        UGMarksheetDocumentId: '',
        VaccinationCertificate: '',
        VaccinationCertificateDocumentId: '',
        Visa: '',
        VisaDocumentId: '',
    };

    let [documentData, setDocumentData] = useState(documentInfo);
    let [hideAddressForm, setHideAddressForm] = useState(true);

    let documentValidationMessage = {
        VoterId: '',
        PanCard: '',
        Passport: '',
        AadharCard: '',
        SSLCCertificate: '',
        HSCCertificate: '',
        UGMarksheet: '',
        VaccinationCertificate: '',
        Visa: '',
    };
    const [message, setMessage] = useState(documentValidationMessage);

    /**
     * PC_P_03 useEffect method get invocked and set the values into the variabels
     * and also invock the getEmployeeAddressGrid() to get the data from DB
     */
    useEffect(() => {
        setEmpId(props.empId);
        sessionData.login_id = encryptStorage.getItem('employeeId');
        sessionData.role = encryptStorage.getItem('role');
        setSession({ ...sessionData });
        getEmployeeAddressGrid();
        getEmployeeCertificateGrid();
    }, [props]);

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeeAddressGrid = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };
            let responsedata = await getEmployeeAddressForGrid(payload);
            setemployeeaddress(responsedata.data.ResponseData[0]);
            setaddressArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeeEducationGrid = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };
            let responsedata = await getEmployeeEducationInfoForGrid(payload);
            setemployeeeducationdetail(responsedata.data.ResponseData[0]);
            seteducationArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeeBankGrid = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };
            let responsedata = await getEmployeeBankInfoForGrid(payload);
            setemployeebankdetail(responsedata.data.ResponseData[0]);
            setbankArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeeCertificateGrid = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };
            let responsedata = await getEmployeeCertificateInfoForGrid(payload);
            setemployeecertificationdetail(responsedata.data.ResponseData[0]);
            setcertificationArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };
    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeePassportGrid = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };
            let responsedata = await getEmployeePassportInfoForGrid(payload);
            setemployeepassportdetail(responsedata.data.ResponseData[0]);
            setpassportArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeeVisaGrid = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };
            let responsedata = await getEmployeeVisaInfoForGrid(payload);
            setemployeeVisadetail(responsedata.data.ResponseData[0]);
        } catch (e) { }
    };

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeePreviousEmploymentGrid = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };

            let responsedata = await getEmployeePreviousEmploymentInfoForGrid(payload);
            setemployeepreviousempdetail(responsedata.data.ResponseData[0]);
            setpreviousemployArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmployeeSkills = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };

            let responsedata = await getEmployeeSkillInfo(payload);
            setemployeeskilldetail(responsedata.data.ResponseData[0]);
            setskillArrLenArrLen(responsedata.data.ResponseData[0].length);
        } catch (e) { }
    };

    function getObjectKeyFromUrl(objectUrl) {
        // Extract the path portion from the URL
        const path = new URL(objectUrl).pathname;

        // Remove leading slash if present
        const cleanedPath = path.startsWith('/') ? path.slice(1) : path;

        // Decode URI components to handle special characters
        const decodedPath = decodeURIComponent(cleanedPath);

        return decodedPath;
    }
    const removeRandomCharacters = (str) => {
        var result = "";
        for (var i = 0; i < str.length; i++) {
            result += str.charAt(i);
            if (i < str.length - 1) {
                i++; // Skip the random character
            }
        }
        return result;
    }

    /**
     * PC_P_12 this function get the data from database and store into the array
     */
    const getEmpDocumentInfo = async () => {
        try {
            let payload = {
                emp_id: empid,
                role: sessionData.role,
            };
            let responsedata = await getEmployeeDocumentInfo(payload);
            if (
                responsedata.data != undefined &&
                responsedata.data != null &&
                responsedata.data.ResponseData != null &&
                responsedata.data.ResponseData.length != 0
            ) {
                ;
                /**
                 * PC_P_13.1 response is stored into the responsedata and it is looped to split the
                 * document url and record id and it is stored into the specific variable based on the document name
                 */
                let documents = [];
                documents.push(responsedata.data.ResponseData[0]);

                for (const doc of documents[0]) {
                    // Replace these with your actual AWS credentials

                    let objectKey = await getS3(doc.document_url); // Replace with the actual object key

                    //     const modifiedString = removeFirstAndLastThree('');

                    //     // Decoding the encoded string
                    //     const decodedStringaccessKey = decode(modifiedString);

                    //     function removeFirstAndLastThree(str) {
                    //        return str.slice(3, -3);
                    //    }
                    //    const modifiedString1 = removeFirstAndLastThree('')
                    //    const decodedStringaccessKeyID = decode(modifiedString1);

                    //     const accessKeyId = decodedStringaccessKey;
                    //     const secretAccessKey = decodedStringaccessKeyID;


                    //     const region = '';
                    //     const bucketName = '';


                    //     // Create an S3 client
                    //     const s3 = new S3({
                    //       accessKeyId,
                    //       secretAccessKey,
                    //       region,
                    //     });

                    //     // Generate a pre-signed URL for downloading the object
                    //     const params = {
                    //       Bucket: bucketName,
                    //       Key: objectKey,
                    //       Expires: 1800, // URL will expire in 0.5 hour
                    //     };
                    let doc_url = objectKey
                    // getS3((url) => {
                    //   if (err) {
                    //     console.error('Error generating pre-signed URL:', err);
                    //   } else {
                    // doc_url=url  
                    if (doc.document_type == 'VoterId') {
                        documentData.VoterId = doc_url;
                        documentData.VoterDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'PanCard') {
                        documentData.PanCard = doc_url;
                        documentData.PanCardDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'Passport') {
                        documentData.Passport = doc_url;
                        documentData.PassportDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'AadharCard') {
                        documentData.AadharCard = doc_url;
                        documentData.AadharCardDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'SSLCCertificate') {
                        documentData.SSLCCertificate = doc_url;
                        documentData.SSLCCertificateDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'HSCCertificate') {
                        documentData.HSCCertificate = doc_url;
                        documentData.HSCCertificateDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'UGMarksheet') {
                        documentData.UGMarksheet = doc_url;
                        documentData.UGMarksheetDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'VaccinationCertificate') {
                        documentData.VaccinationCertificate = doc_url;
                        documentData.VaccinationCertificateDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    if (doc.document_type == 'Visa') {
                        documentData.Visa = doc_url;
                        documentData.VisaDocumentId = doc.id;
                        setDocumentData({ ...documentData });
                    }
                    //   }
                    // });

                    // Create an S3 instance


                };
            }

            let NotaficationData = await getNotificationId(payload);
            setNotification(NotaficationData.data.ResponseData[0]);
            setReportstoId(NotaficationData?.data?.ResponseData[0][0]?.emp_id);
        } catch (e) {
            throw e;
        }
    };

    /**
     * PC_P_21 this function post the document url into the data base
     */
    const postEmpDocumentInfo = async (documentType, documentUrl, documentId) => {

        try {
            setIsLoading(false);
            let request_type;
            let oldvalue;
            let makeRequest = 'false';

            if (documentType == 'VoterId') {
                request_type = documentType == 'VoterId' && documentData.VoterDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.VoterId ? documentData.VoterId : '';
            } else if (documentType == 'PanCard') {
                request_type = documentType == 'PanCard' && documentData.PanCardDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.PanCard ? documentData.PanCard : '';
            } else if (documentType == 'Passport') {
                request_type = documentType == 'Passport' && documentData.PassportDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.Passport ? documentData.Passport : '';
            } else if (documentType == 'AadharCard') {
                request_type = documentType == 'AadharCard' && documentData.AadharCardDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.AadharCard ? documentData.AadharCard : '';
            } else if (documentType == 'SSLCCertificate') {
                request_type = documentType == 'SSLCCertificate' && documentData.SSLCCertificateDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.SSLCCertificate ? documentData.SSLCCertificate : '';
            } else if (documentType == 'HSCCertificate') {
                request_type = documentType == 'HSCCertificate' && documentData.HSCCertificateDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.HSCCertificate ? documentData.HSCCertificate : '';
            } else if (documentType == 'UGMarksheet') {
                request_type = documentType == 'UGMarksheet' && documentData.UGMarksheetDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.UGMarksheet ? documentData.UGMarksheet : '';
            } else if (documentType == 'VaccinationCertificate') {
                request_type =
                    documentType == 'VaccinationCertificate' && documentData.VaccinationCertificateDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.VaccinationCertificate ? documentData.VaccinationCertificate : '';
            } else if (documentType == 'Visa') {
                request_type = documentType == 'Visa' && documentData.VisaDocumentId ? 'Update' : 'Insert';
                oldvalue = documentData.Visa ? documentData.Visa : '';
            }

            if (
                ((props.editaccess == true && empid != sessionData.login_id) ||
                    (props.editaccess == true && sessionData.login_id == empid && reportstoId == sessionData.login_id)) &&
                request_type == 'Update'
            ) {
                makeRequest = 'false';
            } else if (empid == sessionData.login_id && request_type == 'Update') {
                makeRequest = 'true';
            }

            let updateDisplayName =
                documentType == 'VoterId'
                    ? 'Voter ID'
                    : documentType == 'PanCard'
                        ? 'PAN Card'
                        : documentType == 'Passport'
                            ? 'Passport'
                            : documentType == 'AadharCard'
                                ? 'Aadhaar Card'
                                : documentType == 'SSLCCertificate'
                                    ? 'SSLC Certificate'
                                    : documentType == 'HSCCertificate'
                                        ? 'HSC Certificate'
                                        : documentType == 'UGMarksheet'
                                            ? 'UG Marksheet'
                                            : documentType == 'VaccinationCertificate'
                                                ? 'Vaccination Certificate'
                                                : 'Visa';
            let payload = {
                request_type: request_type,
                id: documentId,
                emp_id: empid,
                document_type: documentType,
                document_url: documentUrl,
                created_by: sessionData.login_id,
                oldValue: oldvalue,
                makeRequest: makeRequest,
                cardName: updateDisplayName,
                role: sessionData.role,
            };

            let emp = [];
            notification?.map((obj, index) => {
                emp.push(obj.emp_id);
            });

            let responsedata = await postEmployeeDocumentInfo(payload);
            if (responsedata.data.status == 200) {
                getEmpDocumentInfo();
                setIsLoading(true);

                let profileRequestId = responsedata.data.ResponseData[1];

                if (makeRequest == 'true') {
                    await NotificationTrigger(
                        {
                            title: 'Profile Update',
                            message: 'Profile Request',
                            route: '/profileupdate',
                            state: { state: { profileRequestId: profileRequestId } },
                            to_employee: emp,
                            by: sessionData.login_id,
                        },
                        emp,
                        props.websocket
                    );
                }
                if (request_type == 'Insert') {
                    showToast('Submitted', 'Submitted Succesfully');
                } else if (request_type == 'Update' && makeRequest == 'false') {
                    showToast('Updated', 'Updated Succesfully');
                } else if (request_type == 'Update' && makeRequest == 'true') {
                    showToast('Profile Request submitted', 'Changes will be reflected after the approval');
                }
            }
        } catch (e) {
            setIsLoading(true);
        }
    };

    /**
     *
     *PC_P_36 this function delete the skills data
     */
    const deleteSkill = async (skillId) => {
        try {
            let payload = {
                emp_id: empid,
                id: skillId,
                role: sessionData.role,
            };
            let responsedata = await deleteSkillInfo(payload);
            if (responsedata.status == 200) {
                getEmployeeSkills();
                setDeletePopUp(true);
            }
        } catch (e) { }
    };

    /**
     *
     * PC_P_11 this function call the method based on accordian id
     */
    const accordianClick = (e) => {
        if (e.target.id == 'BankAccountDetails') {
            getEmployeeBankGrid();
        }
        if (e.target.id == 'EducationalDetails') {
            getEmployeeEducationGrid();
        }
        if (e.target.id == 'CertificatesDetails') {
            getEmployeeCertificateGrid();
        }
        if (e.target.id == 'PassportDetails') {
            getEmployeePassportGrid();
            getEmployeeVisaGrid();
        }
        if (e.target.id == 'PreviousEmploymentDetails') {
            getEmployeePreviousEmploymentGrid();
        }
        if (e.target.id == 'SkillsDetails') {
            getEmployeeSkills();
        }
        if (e.target.id == 'DocumentsDetails') {
            getEmpDocumentInfo();
        }
    };

    // const fileUpload = async (ref) => {

    //

    //     // let file = attachment.current.files[0];
    //     // let newFileName = attachment.current.files[0].name;
    //     try {

    //         let file;
    //         let newFileName;

    //         if (ref == "VoterId") {
    //             file = VoterIdattachment.current.files[0];
    //             newFileName = VoterIdattachment.current.files[0].name;
    //         }
    //         if (ref == "PanCard") {
    //             file = PanCardattachment.current.files[0];
    //             newFileName = PanCardattachment.current.files[0].name;
    //         }
    //         if (ref == "Passport") {
    //             file = Passportattachment.current.files[0];
    //             newFileName = Passportattachment.current.files[0].name;
    //         }
    //         if (ref == "AadharCard") {
    //             file = AadharCardattachment.current.files[0];
    //             newFileName = AadharCardattachment.current.files[0].name;
    //         }
    //         if (ref == "SSLCCertificate") {
    //             file = SSLCCertificateattachment.current.files[0];
    //             newFileName = SSLCCertificateattachment.current.files[0].name;
    //         }
    //         if (ref == "HSCCertificate") {
    //             file = HSCCertificateattachment.current.files[0];
    //             newFileName = HSCCertificateattachment.current.files[0].name;
    //         }
    //         if (ref == "UGMarksheet") {
    //             file = UGMarksheetattachment.current.files[0];
    //             newFileName = UGMarksheetattachment.current.files[0].name;
    //         }
    //         if (ref == "VaccinationCertificate") {
    //             file = VaccinationCertificateattachment.current.files[0];
    //             newFileName = VaccinationCertificateattachment.current.files[0].name;
    //         }
    //         if (ref == "Visa") {
    //             file = Visaattachment.current.files[0];
    //             newFileName = Visaattachment.current.files[0].name;
    //         }

    //         if (file && newFileName) {

    //             setIsLoading(false);
    //             let fileData = await Upload(file, newFileName);

    //             setIsLoading(true);
    //             return fileData.location
    //         }
    //     } catch (e) {
    //

    //         setIsLoading(true);
    //     }
    // };

    /**
     *
     * PC_P_20.1 this function upload the file into the S3 bucket
     */

    const fileUpload = async (e) => {
        let file = e.target.files[0];
        let dirName = `${empid}-Profile-Docs`;
        let newFileName = e.target.files[0].name;
        if (file != undefined && newFileName != undefined && file != null && newFileName != null) {
            const typeArr = ['pdf'];
            let type = typeArr.includes(e.target.files[0].type.split('/')[1]);

            if (e.target.files[0].size >= 1000000) {
                setattachmentValidation('File size should be less than 1MB');

                setMessage({ ...message, [e.target.id]: 'File size should be less than 1MB' });
                return false;
            } else if (type == false) {
                setattachmentValidation('The uploaded file should be in PDF or JPG, PNG, JPEG, SVG format');
                //alert("The uploaded file should be in PDF");

                setMessage({ ...message, [e.target.id]: 'The uploaded file should be in PDF' });
                return false;
            } else {
                setattachmentValidation('');
                setMessage({ ...message, [e.target.id]: '' });
            }

            if (e.target.files[0].size <= 1000000 && type == true) {
                setIsLoading(true); // Set loading to true to show a loading indicator, if you have one

                const formData = new FormData();
                formData.append("file", file); // appending the file

                try {
                    // Make an API request to your backend route

                    let fileLocation = await uploadBackend(file, newFileName, dirName);

                    if (fileLocation) { // Pre-signed URL from the backend
                        setImageUrl(fileLocation); // Set image URL for display
                        return fileLocation; // Return the pre-signed URL for further processing
                    } else {
                        setMessage({ ...message, [e.target.id]: 'File upload failed. Please try again.' });
                        return false; // Exit the function if the upload failed
                    }
                } catch (error) {
                    setMessage({ ...message, [e.target.id]: 'File upload failed. Please try again.' });
                    return false; // Exit the function if there was an error during upload
                } finally {
                    setIsLoading(false); // Set loading to false once the upload process is complete
                }
            } else {
                return false;
            }
        }

    };

    /**
     * PC_P_20.2 this function define the parameter it will be passed into the postEmpDocumentInfo() function
     */
    const upload = async (e) => {
        try {
            let documentType = e.target.id;
            ;
            let fileData = await fileUpload(e);
            if (fileData != undefined && fileData != false) {
                let documentId;
                documentId =
                    documentType == 'VoterId'
                        ? documentData.VoterDocumentId
                        : documentType == 'PanCard'
                            ? documentData.PanCardDocumentId
                            : documentType == 'Passport'
                                ? documentData.PassportDocumentId
                                : documentType == 'AadharCard'
                                    ? documentData.AadharCardDocumentId
                                    : documentType == 'SSLCCertificate'
                                        ? documentData.SSLCCertificateDocumentId
                                        : documentType == 'HSCCertificate'
                                            ? documentData.HSCCertificateDocumentId
                                            : documentType == 'UGMarksheet'
                                                ? documentData.UGMarksheetDocumentId
                                                : documentType == 'VaccinationCertificate'
                                                    ? documentData.VaccinationCertificateDocumentId
                                                    : documentType == 'Visa'
                                                        ? documentData.VisaDocumentId
                                                        : null;

                postEmpDocumentInfo(documentType, fileData, documentId);
            }
        } catch (e) {
            setIsLoading(true);
        }
    };

    /**
     *
     * PC_P_34 this function set the values into the state variable
     */
    const addresseditclick = (e) => {
        setISAddressClick(true);
        setaddressType(e.target.name);
        setmode('Edit');
    };

    /**
     *
     * PC_P_28 this function set the values into the state variable
     */
    const Bankeditclick = (e) => {
        setIsBankClicked(true);
        setbankId(e.target.id);
        setmode('Edit');
    };

    /**
     *
     * PC_P_29 this function set the values into the state variable
     */
    const Educationeditclick = (e) => {
        setIsEducationClicked(true);
        seteducationId(e.target.id);
        setmode('Edit');
    };

    /**
     * PC_P_30 this function set the values into the state variable
     */

    const Certificateeditclick = (e) => {
        setIsCertificateClicked(true);
        setcertificateId(e.target.id);
        setmode('Edit');
    };

    /**
     * PC_P_31 this function set the values into the state variable
     */
    const Passporteditclick = (e) => {
        setIsPassportClicked(true);
        setSection(e.target.name);
        setpassportId(e.target.id);
        setmode('Edit');
    };

    /**
     * PC_P_32 this function set the values into the state variable
     */
    const PreviousEmpeditclick = (e) => {
        setIsPreEmployClicked(true);
        setpreviousEmpId(e.target.id);
        setmode('Edit');
    };

    /**
     *
     * PC_P_34 this function set the values into the state variable
     */
    const addressAddclick = () => {
        setISAddressClick(true);
        setaddressType('');
        setmode('');
    };

    /**
     *
     * PC_P_28 this function set the values into the state variable
     */
    const bankAddclick = () => {
        setIsBankClicked(true);
        setbankId(0);
        setmode('');
    };

    /**
     * PC_P_29 this function set the values into the state variable
     */
    const educationAddclick = () => {
        setIsEducationClicked(true);
        seteducationId(0);
        setmode('');
    };

    /**
     * PC_P_30 this function set the values into the state variable
     */
    const certificateAddclick = () => {
        setIsCertificateClicked(true);
        setcertificateId(0);
        setmode('');
    };

    /**
     * PC_P_31 this function set the values into the state variable
     */
    const passportAddclick = () => {
        setIsPassportClicked(true);
        setpassportId(0);
        setmode('');
    };

    /**
     * PC_P_32 this function set the values into the state variable
     */
    const PreviousEmpAddclick = () => {
        setIsPreEmployClicked(true);
        setpreviousEmpId(0);
        setmode('');
    };

    /**
     * PC_P_33 this function set the values into the state variable
     */
    const SkillAddclick = () => {
        setIsSkillClicked(true);
        setEmpId(props.empId);
        setmode('');
    };

    /**
     *
     * PC_P_36.1 this function set the values into the state variable
     */
    const SlillDeleteClick = (e) => {
        setskillId(e.target.id);
        setmode('');
        setDeletePopUp(false);
    };

    /**
     * PC_P_36.2 this function invock the deleteSkill() function to delete the record
     */
    const yesClicked = () => {
        deleteSkill(skillId);
    };

    /**
     * PC_P_36.3 this function hide the confirmation popup
     */
    const cancelClickedDelete = () => {
        setDeletePopUp(true);
    };

    const showToast = (headerMessage, bodyMessage) => {
        //props.setHideToast(false);
        props.setHideToast(headerMessage, bodyMessage);
    };

    /**
     *
     * PC_P_19 this function will bind the data into the address section
     */
    const buildAddressBody = () => {
        try {
            return employeeaddress.map((obj, index) => {
                return (
                    <div className="col-md-4">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing mb-2">
                                    <h5 className="card-title profile-card-title">{obj.address_type}</h5>
                                    {empid == sessionData.login_id ||
                                        sessionData.role == 'Hr Manager' ||
                                        sessionData.role == 'Hr' ||
                                        sessionData.role == 'Admin' ? (
                                        <div className="dropdown">
                                            <img
                                                className="dropdown-toggle profile-more-action"
                                                src="/Images/profile-more-icon.svg"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                alt="More Icon"
                                            />
                                            <ul className="dropdown-menu profile-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item profile-dropdown-item" /*href = {"/AddressDetail?EmpId=AVA2407&pMode=Edit&addressType=Permanent Address"}*/
                                                        name={obj.address_type}
                                                        onClick={(e) => addresseditclick(e)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#CurrentAddressPopup"
                                                    >
                                                        <img className="me-2" src="/Images/profile-edit-blue.svg" alt="Edit Icon" />
                                                        Edit
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>
                                <p className="card-text profile-card-text mb-1 regular-text">
                                    No. {obj.house_num}, {obj.street},
                                </p>
                                <p className="card-text profile-card-text mb-1 regular-text">
                                    {obj.area}, {obj.town}, {obj.country},
                                </p>
                                <p className="card-text profile-card-text mb-1 regular-text">
                                    {obj.state} - {obj.pincode}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };
    /**
     *
     * PC_P_19 this function will bind the data into the bank detail section
     */
    const buildBankBody = () => {
        try {
            return employeebankdetail.map((obj, index) => {
                 const downloadDocument = async (obj) => {
                // Step 1: Retrieve the presigned URL
                const doc_url = await getS3(obj);
                setDocUrl(doc_url);
                return doc_url;

            }

                downloadDocument(obj.logo_url, "1")
                return (
                    <div className="col-md-4">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing mb-2">
                                    <div className>
                                            <img src={DOMPurify.sanitize(docUrl)}
                alt="ICICI Bank Icon" />
                                        <h5 className="card-title profile-card-title mt-2">{obj.bank_name}</h5>
                                    </div>
                                    {empid == sessionData.login_id ||
                                        sessionData.role == 'Hr Manager' ||
                                        sessionData.role == 'Hr' ||
                                        sessionData.role == 'Admin' ? (
                                        <div className="dropdown">
                                            <img
                                                className="dropdown-toggle profile-more-action"
                                                src="/Images/profile-more-icon.svg"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                alt="More Icon"
                                            />
                                            <ul className="dropdown-menu profile-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="#"
                                                        id={obj.id}
                                                        onClick={(e) => Bankeditclick(e)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#BankDetailsPopup"
                                                    >
                                                        <img className="me-2" src="/Images/profile-edit-blue.svg" alt="Edit Icon" />
                                                        Edit
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Account Type</div>
                                    <div className="profile-list-value">{obj.account_type}</div>
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Account Number</div>
                                    <div className="profile-list-value">{obj.account_number}</div>
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">IFSC Code</div>
                                    <div className="profile-list-value">{obj.ifsc_code}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    /**
     *
     * PC_P_19 this function will bind the data into the educational detail section
     */
    const buildEducationBody = () => {
        try {
            return employeeeducationdetail.map((obj, index) => {
                let m = moment(new Date(obj.year_of_passing));

                let PassingfYear = m.format('YYYY');

                var tipCount;
                var instituteName;
                if (obj.institute_name.length > 35) {
                    instituteName = obj.institute_name.substring(0, 35);
                    instituteName = instituteName + '...';
                    tipCount = 1;
                } else {
                    instituteName = obj.institute_name;
                    tipCount = 0;
                }

                return (
                    <div className="col-md-4">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing mb-2">
                                    <h5 className="card-title profile-card-title">{obj.education_qualification}</h5>
                                    {empid == sessionData.login_id ||
                                        sessionData.role == 'Hr Manager' ||
                                        sessionData.role == 'Hr' ||
                                        sessionData.role == 'Admin' ? (
                                        <div className="dropdown">
                                            <img
                                                className="dropdown-toggle profile-more-action"
                                                src="/Images/profile-more-icon.svg"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                alt="More Icon"
                                            />
                                            <ul className="dropdown-menu profile-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="#"
                                                        id={obj.id}
                                                        onClick={(e) => Educationeditclick(e)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#EducationalDetailsPopup"
                                                    >
                                                        <img className="me-2" src="/Images/profile-edit-blue.svg" alt="Edit Icon" />
                                                        Edit
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>
                                <p className="card-text profile-card-text mb-1 regular-text">{obj.field_of_study}</p>
                                <a
                                    className={tipCount == 0 ? 'card-tooltip-color tooltipCursor ' : 'card-tooltip-color'}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title={tipCount == 1 ? obj.institute_name : ''}
                                >
                                    {instituteName}
                                </a>
                                {/* <p className="card-text profile-card-text mb-1 regular-text">{obj.institute_name}</p> */}
                                <p className="card-text profile-card-text mb-1 regular-text">{PassingfYear}</p>
                                <div className="card-text profile-edu-percent text-end mb-1">
                                    <span className="profile-circle" />
                                    {obj.percentage}%
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    /**
     *
     * PC_P_19 this function will bind the data into the certificate detail section
     */
    const buildCertificateBody = () => {
        try {
            return employeecertificationdetail.map((obj, index) => {
                let m = moment(new Date(obj.year_of_completion));
                let yearOfCompletion = m.format('YYYY');

                return (
                    <div className="col-md-4">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing mb-2">
                                    <h5 className="card-title profile-card-title">{obj.certification_in}</h5>
                                    {empid == sessionData.login_id ||
                                        sessionData.role == 'Hr Manager' ||
                                        sessionData.role == 'Hr' ||
                                        sessionData.role == 'Admin' ? (
                                        <div className="dropdown">
                                            <img
                                                className="dropdown-toggle profile-more-action"
                                                src="/Images/profile-more-icon.svg"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                alt="More Icon"
                                            />
                                            <ul className="dropdown-menu profile-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        id={obj.id}
                                                        onClick={(e) => Certificateeditclick(e)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#CertificateDetailsPopup"
                                                    >
                                                        <img className="me-2" src="/Images/profile-edit-blue.svg" alt="Edit Icon" />
                                                        Edit
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>
                                <p className="card-text profile-card-text mb-1 regular-text">{obj.certified_by}</p>
                                <p className="card-text profile-card-text mb-1 regular-text">{yearOfCompletion}</p>
                                <div className="card-text profile-edu-percent text-end mb-1">
                                    <a className="profile-view" style={{cursor:"pointer"}} onClick={async () => {

                                        window.open(await getS3(obj.certificate_url), "_blank");


                                    }} target="_blank">
                                        View
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                );

            });
        } catch (e) { }
    };

    /**
     *
     * PC_P_19 this function will bind the data into the passport detail section
     */
    const buildPassportDetailBody = () => {
        try {
            return employeepassportdetail.map((obj, index) => {
                let dateofissue = moment(new Date(obj.date_of_issue));
                let dateofexpiry = moment(new Date(obj.date_of_expiry));

                let DateOfIssue = dateofissue.format('YYYY');
                let DateOfExpiry = dateofexpiry.format('YYYY');

                return (
                    <div className="col-md-4">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing mb-2">
                                    <h5 className="card-title profile-card-title mt-2">Passport</h5>
                                    {empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr' ? (
                                        <div className="dropdown">
                                            <img
                                                className="dropdown-toggle profile-more-action"
                                                src="/Images/profile-more-icon.svg"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                alt="More Icon"
                                            />
                                            <ul className="dropdown-menu profile-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        name="Passport"
                                                        id={obj.id}
                                                        onClick={(e) => Passporteditclick(e)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#PassportDetailsPopup"
                                                    >
                                                        <img className="me-2" src="/Images/profile-edit-blue.svg" alt="Edit Icon" />
                                                        Edit
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>

                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Passport No</div>
                                    <div className="profile-list-value">{obj.passport_num}</div>
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">ECNR</div>
                                    <div className="profile-list-value">{obj.ecnr ? obj.ecnr : '-'}</div>
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Place of Issue</div>
                                    <div className="profile-list-value">{obj.place_of_issue}</div>
                                </div>
                                <p className="card-text profile-card-text mb-1 regular-text">
                                    {DateOfIssue} - {DateOfExpiry}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    /**
     *
     * PC_P_19 this function will bind the data into the visadetail section
     */

    const buildVisaDetailBody = () => {
        try {
            return employeeVisadetail.map((obj, index) => {
                let dateofissue = moment(new Date(obj.date_of_issue));
                let dateofexpiry = moment(new Date(obj.date_of_expiry));
                let DateOfIssue = dateofissue.format('YYYY');
                let DateOfExpiry = dateofexpiry.format('YYYY');

                let tipCount;
                let visa;
                let countrytipCount;
                let country;
                if (obj.visa_number.length > 15) {
                    visa = obj.visa_number.substring(0, 15);
                    visa = visa + '...';
                    tipCount = 1;
                } else {
                    visa = obj.visa_number;
                    tipCount = 0;
                }

                if (obj.country.length > 15) {
                    country = obj.country.substring(0, 15);
                    country = country + '...';
                    countrytipCount = 1;
                } else {
                    country = obj.country;
                    countrytipCount = 0;
                }

                return (
                    <div className="col-md-4">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing mb-2">
                                    <h5 className="card-title profile-card-title mt-2">Visa</h5>
                                    {empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr' ? (
                                        <div className="dropdown">
                                            <img
                                                className="dropdown-toggle profile-more-action"
                                                src="/Images/profile-more-icon.svg"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                alt="More Icon"
                                            />
                                            <ul className="dropdown-menu profile-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        name="Visa"
                                                        id={obj.id}
                                                        onClick={(e) => Passporteditclick(e)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#PassportDetailsPopup"
                                                    >
                                                        <img className="me-2" src="/Images/profile-edit-blue.svg" alt="Edit Icon" />
                                                        Edit
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>

                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Visa No</div>
                                    <div
                                        className={tipCount == 0 ? 'card-tooltip-color tooltipCursor ' : 'card-tooltip-color'}
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title={tipCount == 1 ? obj.visa_number : ''}
                                    >
                                        {visa}
                                    </div>
                                    {/* <div className="profile-list-value">{visa}</div> */}
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Visa Type</div>
                                    <div className="profile-list-value">{obj.visa_type}</div>
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Country</div>
                                    <div
                                        className={countrytipCount == 0 ? 'card-tooltip-color tooltipCursor ' : 'card-tooltip-color'}
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title={countrytipCount == 1 ? obj.country : ''}
                                    >
                                        {country}
                                    </div>
                                    {/* <div className="profile-list-value">{obj.country}</div> */}
                                </div>
                                <p className="card-text profile-card-text mb-1 regular-text">
                                    {DateOfIssue} - {DateOfExpiry}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    /**
     *
     * PC_P_19 this function will bind the data into the previous employment section
     */
    const buildpreviousEmpDetailBody = () => {
        try {
            return employeepreviousempdetail.map((obj, index) => {
                let dateofjoining = moment(new Date(obj.date_of_join));
                let dateofreleving = moment(new Date(obj.date_of_releave));
                let DateOfJoining = dateofjoining.format('MMM,DD YYYY');
                let DateOfReleiving = dateofreleving.format('MMM,DD YYYY');

                var tipCount;
                var companyName;
                if (obj.name_of_company.length > 15) {
                    companyName = obj.name_of_company.substring(0, 15);
                    companyName = companyName + '...';
                    tipCount = 1;
                } else {
                    companyName = obj.name_of_company;
                    tipCount = 0;
                }

                var DesignationCount;
                var Designation;
                if (obj.designation.length > 15) {
                    Designation = obj.designation.substring(0, 15);
                    Designation = Designation + '...';
                    DesignationCount = 1;
                } else {
                    Designation = obj.designation;
                    DesignationCount = 0;
                }

                return (
                    <div className="col-md-4">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing mb-2">
                                    <h5 className="card-title profile-card-title mt-2">Company {index + 1}</h5>
                                    {empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr' ? (
                                        <div className="dropdown">
                                            <img
                                                className="dropdown-toggle profile-more-action"
                                                src="/Images/profile-more-icon.svg"
                                                id="dropdownMenuButton1"
                                                data-bs-toggle="dropdown"
                                                aria-expanded="false"
                                                alt="More Icon"
                                            />
                                            <ul className="dropdown-menu profile-dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                <li>
                                                    <a
                                                        className="dropdown-item"
                                                        href="#"
                                                        id={obj.id}
                                                        onClick={(e) => PreviousEmpeditclick(e)}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#previousemploymentpopup"
                                                    >
                                                        <img className="me-2" src="/Images/profile-edit-blue.svg" alt="Edit Icon" />
                                                        Edit
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Company Name</div>
                                    <div className="profile-list-value">
                                        <a
                                            className={tipCount == 0 ? 'card-tooltip-color tooltipCursor ' : 'card-tooltip-color'}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title={tipCount == 1 ? obj.name_of_company : ''}
                                        >
                                            {companyName}
                                        </a>
                                    </div>
                                </div>
                                <div className="profile-list-panel">
                                    <div className="profile-list-label">Designation </div>
                                    <div className="profile-list-value">
                                        <a
                                            className={tipCount == 0 ? 'card-tooltip-color tooltipCursor ' : 'card-tooltip-color'}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            title={tipCount == 1 ? obj.designation : ''}
                                        >
                                            {Designation}
                                        </a>
                                    </div>
                                </div>
                                {/* <div className="profile-list-panel">
                                    <div className="profile-list-label">Email</div>
                                    <div className="profile-list-value">{obj.email_id}</div>
                                </div> */}
                                <p className="card-text profile-card-text mb-1 regular-text">
                                    {DateOfJoining} - {DateOfReleiving}
                                </p>
                                <div className="card-text profile-edu-percent text-end mb-1">{obj.ctc}LPA</div>
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    /**
     *
     * PC_P_19 this function will bind the data into the skill details section
     */
    const buildskillBody = () => {
        try {
            return employeeskilldetail.map((obj, index) => {
                let tipCount;
                let SkillName;
                if (obj.skill_name.length > 15) {
                    SkillName = obj.skill_name.substring(0, 15);
                    SkillName = SkillName + '...';
                    tipCount = 1;
                } else {
                    SkillName = obj.skill_name;
                    tipCount = 0;
                }

                return (
                    <div className="col-md-4 mb-3">
                        <div className="card profile-card">
                            <div className="card-body">
                                <div className="profile-spacing">
                                    {/* <h5 className="card-title profile-card-title mt-2">{obj.skill_name}</h5> */}
                                    <h5
                                        className="card-title profile-card-title mt-2"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title={tipCount == 1 ? obj.skill_name : ''}
                                    >
                                        {SkillName}
                                    </h5>
                                    {empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr' ? (
                                        <div className="profile-skill-cancel">
                                            <a>
                                                <img
                                                    src="/Images/profile-clear-icon.svg"
                                                    className="cursor-pointer"
                                                    alt="Clear icon"
                                                    id={obj.id}
                                                    onClick={(e) => SlillDeleteClick(e)}
                                                />
                                            </a>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            });
        } catch (e) { }
    };

    return (
        <>
            <Loader isLoading={isLoading} />

            {/* <div className="row" id="profile-tab-content" style={{ display: 'flex' }}> */}
            <div className="col-md-12">
                <div className="accordion bg-white p-4" id="profile">
                    {/*certificate detail */}
                    <div className="accordion-item-profile border-0 mb-4">
                        <div className="profile-between-spacing profile-header-border position-relative" id="CertificatesDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-certificate-icon.svg" alt="Certificate Icon" /> Certificates
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto bg-transparent px-0"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#CertificatesDetailsContent"
                                aria-expanded="false"
                                aria-controls="CertificatesDetails"
                                id="CertificatesDetails"
                                onClick={(e) => accordianClick(e)}
                            ></button>
                            {certificationArrLen >= 0 && (empid == sessionData.login_id || sessionData.role == 'Hr Manager') ? (
                                <a
                                    href="#"
                                    className="profile-add-accordion text-decoration-none"
                                    onClick={() => certificateAddclick()}
                                    data-bs-toggle="modal"
                                    data-bs-target="#CertificateDetailsPopup"
                                >
                                    <img src="/Images/profile-add-icon.svg" alt="Add Icon" className="p-1" />
                                    Add New
                                </a>
                            ) : null}
                        </div>
                        <div
                            id="CertificatesDetailsContent"
                            className="accordion-collapse collapse show"
                            aria-labelledby="CertificatesDetails"
                            data-bs-parent="#profile"
                            style={{}}
                        >
                            {/* {certificationArrLen <= 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => certificateAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            href="#"
                                            className="profile-add"
                                            onClick={() => certificateAddclick()}
                                            data-bs-toggle="modal"
                                            data-bs-target="#CertificateDetailsPopup"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add</span>
                                        </a>
                                    </div>
                                </div>
                            ) : null} */}
                            {certificationArrLen != 0 ? (
                                <div className="accordion-body p-0 mt-3">
                                    <div className="row">
                                        {' '}
                                        {/* implement certificate */}
                                        {buildCertificateBody()}
                                    </div>
                                </div>
                            ) : (
                                <div className="accordion-body p-0 mt-3">
                                    <div className="row">
                                        {' '}
                                        {/* implement certificate */}
                                        <div className="text-center">
                                            <p className="font-16 semibold-text text-grey">
                                                This employee doesn't have any certifications attached
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Address detail */}
                    <div className="accordion-item-profile border-0 mb-4">
                        <div className="profile-between-spacing profile-header-border" id="AddressDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-address-icon.svg" alt="Address Icon" /> Address Details
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto bg-transparent px-0 collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#AddressDetailsContent"
                                aria-expanded="true"
                                aria-controls="AddressDetails"
                            ></button>
                        </div>
                        <div
                            id="AddressDetailsContent"
                            className="accordion-collapse collapse"
                            aria-labelledby="AddressDetails"
                            data-bs-parent="#profile"
                        >
                            {addressArrLen == 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => addressAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            href="#"
                                            className="profile-add"
                                            onClick={() => addressAddclick()}
                                            data-bs-toggle="modal"
                                            data-bs-target="#CurrentAddressPopup"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add</span>
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <div className="accordion-body p-0 mt-3">
                                    <div className="row">{buildAddressBody()}</div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/*Bank detail */}
                    <div className="accordion-item-profile border-0 mb-4">
                        <h2 className="profile-between-spacing profile-header-border" id="BankAccountDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-bank-icon.svg" alt="Bank Icon" /> Bank Accounts
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto collapsed bg-transparent px-0"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#BankAccountDetailsContent"
                                aria-expanded="false"
                                aria-controls="BankAccountDetails"
                                id="BankAccountDetails"
                                onClick={(e) => accordianClick(e)}
                            ></button>
                        </h2>
                        <div
                            id="BankAccountDetailsContent"
                            className="accordion-collapse collapse"
                            aria-labelledby="BankAccountDetails"
                            data-bs-parent="#profile"
                        >
                            {bankArrLen <= 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => bankAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            href="#"
                                            className="profile-add"
                                            onClick={() => bankAddclick()}
                                            data-bs-toggle="modal"
                                            data-bs-target="#BankDetailsPopup"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add</span>
                                        </a>
                                    </div>
                                </div>
                            ) : (
                                <div className="accordion-body p-0 mt-3">
                                    <div className="row">{buildBankBody()}</div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/*Educational detail */}
                    <div className="accordion-item-profile border-0 mb-4">
                        <div className="profile-between-spacing profile-header-border position-relative" id="EducationalDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-education-icon.svg" alt="Education Icon" /> Educational Details
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto collapsed bg-transparent px-0"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#EducationalDetailsContent"
                                aria-expanded="false"
                                aria-controls="EducationalDetails"
                                id="EducationalDetails"
                                onClick={(e) => accordianClick(e)}
                            ></button>
                            {educationArrLen > 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <a
                                    href="#"
                                    className="profile-add-accordion text-decoration-none"
                                    onClick={() => educationAddclick()}
                                    data-bs-toggle="modal"
                                    data-bs-target="#EducationalDetailsPopup"
                                >
                                    <img src="/Images/profile-add-icon.svg" alt="Add Icon" className="p-1" />
                                    Add New
                                </a>
                            ) : null}
                        </div>
                        <div
                            id="EducationalDetailsContent"
                            className="accordion-collapse collapse"
                            aria-labelledby="EducationalDetails"
                            data-bs-parent="#profile"
                        >
                            {educationArrLen <= 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => educationAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            href="#"
                                            className="profile-add"
                                            onClick={() => educationAddclick()}
                                            data-bs-toggle="modal"
                                            data-bs-target="#EducationalDetailsPopup"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add</span>
                                        </a>
                                    </div>
                                </div>
                            ) : null}
                            <div className="accordion-body p-0 mt-3">
                                <div className="row">{buildEducationBody()}</div>
                            </div>
                        </div>
                    </div>

                    <div className="accordion-item-profile border-0 mb-4">
                        <div className="profile-between-spacing profile-header-border position-relative" id="PassportDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-passport-icon.svg" alt="Passport Icon" /> Passport &amp; Visa
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto collapsed bg-transparent px-0"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#PassportDetailsContent"
                                aria-expanded="false"
                                aria-controls="PassportDetails"
                                id="PassportDetails"
                                onClick={(e) => accordianClick(e)}
                            ></button>
                            {passportArrLen > 0 && (empid == sessionData.login_id || sessionData.role == 'Hr Manager') ? (
                                <a
                                    href="#"
                                    className="profile-add-accordion text-decoration-none"
                                    onClick={() => passportAddclick()}
                                    data-bs-toggle="modal"
                                    data-bs-target="#PassportDetailsPopup"
                                >
                                    <img src="/Images/profile-add-icon.svg" alt="Add Icon" className="p-1" />
                                    Add New
                                </a>
                            ) : null}
                        </div>
                        <div
                            id="PassportDetailsContent"
                            className="accordion-collapse collapse"
                            aria-labelledby="PassportDetails"
                            data-bs-parent="#profile"
                        >
                            {passportArrLen <= 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => passportAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            href="#"
                                            className="profile-add"
                                            onClick={() => passportAddclick()}
                                            data-bs-toggle="modal"
                                            data-bs-target="#PassportDetailsPopup"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add</span>
                                        </a>
                                    </div>
                                </div>
                            ) : null}
                            <div className="accordion-body p-0 mt-3">
                                <div className="row">
                                    {buildPassportDetailBody()}
                                    {buildVisaDetailBody()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item-profile border-0 mb-4">
                        <div className="profile-between-spacing profile-header-border position-relative" id="PreviousEmploymentDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-previous-emp-icon.svg" alt="Previous Employment Icon" /> Previous
                                Employment
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto collapsed bg-transparent px-0"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#PreviousEmploymentDetailsContent"
                                aria-expanded="false"
                                aria-controls="PreviousEmploymentDetails"
                                id="PreviousEmploymentDetails"
                                onClick={(e) => accordianClick(e)}
                            ></button>
                            {previousemployArrLen > 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <a
                                    href="#"
                                    className="profile-add-accordion text-decoration-none"
                                    onClick={() => PreviousEmpAddclick()}
                                    data-bs-toggle="modal"
                                    data-bs-target="#previousemploymentpopup"
                                >
                                    <img src="/Images/profile-add-icon.svg" alt="Add Icon" className="p-1" />
                                    Add New
                                </a>
                            ) : null}
                        </div>
                        <div
                            id="PreviousEmploymentDetailsContent"
                            className="accordion-collapse collapse"
                            aria-labelledby="PreviousEmploymentDetails"
                            data-bs-parent="#profile"
                        >
                            {previousemployArrLen <= 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => PreviousEmpAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            href="#"
                                            className="profile-add"
                                            onClick={() => PreviousEmpAddclick()}
                                            data-bs-toggle="modal"
                                            data-bs-target="#previousemploymentpopup"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add</span>
                                        </a>
                                    </div>
                                </div>
                            ) : null}
                            <div className="accordion-body p-0 mt-3">
                                <div className="row">
                                    {buildpreviousEmpDetailBody()}

                                    {/* previous emp */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item-profile border-0 mb-4">
                        <div className="profile-between-spacing profile-header-border position-relative" id="SkillsDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-skill-icon.svg" alt="Skills Icon" /> Skills
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto collapsed bg-transparent px-0"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#SkillsDetailsContent"
                                aria-expanded="false"
                                aria-controls="SkillsDetails"
                                id="SkillsDetails"
                                onClick={(e) => accordianClick(e)}
                            ></button>
                            {skillArrLen > 0 && (empid == sessionData.login_id || sessionData.role == 'Hr Manager') ? (
                                <a
                                    href="#"
                                    className="profile-add-accordion text-decoration-none"
                                    onClick={() => SkillAddclick()}
                                    data-bs-toggle="modal"
                                    data-bs-target="#SkillDetailsPopup"
                                >
                                    <img src="/Images/profile-add-icon.svg" alt="Add Icon" className="p-1" />
                                    Add New
                                </a>
                            ) : null}
                        </div>
                        <div
                            id="SkillsDetailsContent"
                            className="accordion-collapse collapse"
                            aria-labelledby="SkillsDetails"
                            data-bs-parent="#profile"
                        >
                            {skillArrLen <= 0 &&
                                (empid == sessionData.login_id || sessionData.role == 'Hr Manager' || sessionData.role == 'Hr') ? (
                                <div
                                    className="accordion-body profile-accordion-body"
                                    onClick={() => SkillAddclick()}
                                    style={{ display: 'show', cursor: 'pointer' }}
                                >
                                    <div className="profile-center-spacing">
                                        <a
                                            href="#"
                                            className="profile-add"
                                            onClick={() => SkillAddclick()}
                                            data-bs-toggle="modal"
                                            data-bs-target="#SkillDetailsPopup"
                                        >
                                            <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                            <span>Add</span>
                                        </a>
                                    </div>
                                </div>
                            ) : null}
                            <div className="accordion-body p-0 mt-3">
                                <div className="row">{buildskillBody()}</div>
                            </div>
                        </div>
                    </div>
                    <div className="accordion-item-profile border-0 mb-4">
                        <div className="profile-between-spacing profile-header-border position-relative" id="DocumentsDetails">
                            <div className="profile-accordion-header">
                                <img className="me-2" src="/Images/profile-document-icon.svg" alt="Documents Icon" /> Documents
                            </div>
                            <button
                                className="accordion-button profile-acc-icon w-auto collapsed bg-transparent px-0"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#DocumentsDetailsContent"
                                aria-expanded="false"
                                aria-controls="DocumentsDetails"
                                id="DocumentsDetails"
                                onClick={(e) => accordianClick(e)}
                            ></button>
                            {/* <a href="#" className="profile-add-accordion text-decoration-none">
                                <img src="/Images/profile-add-icon.svg" alt="Add Icon" />
                                Add New
                            </a> */}
                        </div>
                        <div
                            id="DocumentsDetailsContent"
                            className="accordion-collapse collapse"
                            aria-labelledby="DocumentsDetails"
                            data-bs-parent="#profile"
                        >
                            <div className="accordion-body profile-accordion-body" style={{ display: 'none' }}>
                                <div className="profile-center-spacing">
                                    <a href="#" className="profile-add">
                                        <img className="me-2" src="/Images/profile-add-icon.svg" alt="Add icon" />
                                        <span>Add</span>
                                    </a>
                                </div>
                            </div>

                            <div className="accordion-body p-0 mt-3">
                                <div className="row">
                                    {/* <div className="col-md-4 mb-3">
                                        {documentData.VoterId ? null : <div className="card profile-card">
                                            <div className="card-body">
                                                <div className="profile-spacing">
                                                    <h5 className="card-title profile-card-title mt-2">Voter ID</h5>
                                                    <div className="profile-upload-btn">
                                                        <label htmlFor="VoterId" className="profile-custom-file-upload">
                                                            <img className="me-2" src="/Images/profile-upload-icon.svg" alt="Upload Icon" />
                                                            Upload
                                                        </label>
                                                        <input id="VoterId" className="profile-file-upload" type="file" onChange={(e) => upload(e)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        {documentData.VoterId ? <div className="card" style={{ width: '21rem' }}>
                                            <a href={documentData.VoterId} target='_blank'> <img src="/Images/voterId.png" className="document-width" alt="Document-image" /> </a>
                                            <div className="card-body hive-profile-footer-bg">
                                                <div className="d-flex justify-content-between">
                                                    <h5 className="card-title bold-text font-16">Voter ID</h5>
                                                    <div>
                                                        <button type="button " className="btn p-0 align-top shadow-none" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <img src="/Images/kebab-menu.svg" /></button>
                                                        <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown" style={{}}>
                                                            <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : null}

                                    </div> */}

                                    <div className="col-md-4 mb-3">
                                        {documentData.AadharCard ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">Aadhaar Card</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="AadharCard" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="AadharCard"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.AadharCard ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.AadharCard)} target="_blank">
                                                    {' '}
                                                    <img src="/Images/document-image.png" className="document-width" alt="Document-image" />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">Aadhaar Card</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="AadharCard"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="AadharCard"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        {message.AadharCard ? <label className="hive-form-mandatory">{message.AadharCard}</label> : null}
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        {documentData.PanCard ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">PAN Card</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="PanCard" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="PanCard"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.PanCard ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.PanCard)} target="_blank">
                                                    {' '}
                                                    <img src="/Images/PanCard.png" className="document-width" alt="Document-image" />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">PAN Card</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="PanCard"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="PanCard"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        {message.PanCard ? <label className="hive-form-mandatory">{message.PanCard}</label> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        {documentData.Passport ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">Passport</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="Passport" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="Passport"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.Passport ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.Passport)} target="_blank">
                                                    {' '}
                                                    <img src="/Images/Passport.png" className="document-width" alt="Document-image" />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">Passport</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="Passport"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="Passport"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        {message.Passport ? <label className="hive-form-mandatory">{message.Passport}</label> : null}
                                    </div>
                                    {/* <div className="col-md-4 mb-3">
                                        {documentData.AadharCard ? null : <div className="card profile-card">
                                            <div className="card-body">
                                                <div className="profile-spacing">
                                                    <h5 className="card-title profile-card-title mt-2">Aadhaar Card</h5>
                                                    <div className="profile-upload-btn">
                                                        <label htmlFor="AadharCard" className="profile-custom-file-upload">
                                                            <img className="me-2" src="/Images/profile-upload-icon.svg" alt="Upload Icon" />
                                                            Upload
                                                        </label>
                                                        <input id="AadharCard" className="profile-file-upload" type="file" onChange={(e) => upload(e)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}

                                        {documentData.AadharCard ? <div className="card" style={{ width: '21rem' }}>
                                            <a href={documentData.AadharCard} target='_blank' > <img src="/Images/document-image.png" className="document-width" alt="Document-image" /></a>
                                            <div className="card-body hive-profile-footer-bg">
                                                <div className="d-flex justify-content-between">
                                                    <h5 className="card-title bold-text font-16">Aadhaar Card</h5>
                                                    <div>
                                                        <button type="button " className="btn p-0 align-top shadow-none" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <img src="/Images/kebab-menu.svg" /></button>
                                                        <ul className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown" style={{}}>
                                                            <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> : null}

                                    </div> */}

                                    <div className="col-md-4 mb-3">
                                        {documentData.VoterId ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">Voter ID</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="VoterId" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="VoterId"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {documentData.VoterId ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.VoterId)} target="_blank">
                                                    {' '}
                                                    <img src="/Images/voterId.png" className="document-width" alt="Document-image" />{' '}
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">Voter ID</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="VoterId"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="VoterId"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        {message.VoterId ? <label className="hive-form-mandatory">{message.VoterId}</label> : null}
                                    </div>

                                    <div className="col-md-4 mb-3">
                                        {documentData.SSLCCertificate ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">SSLC Certificate</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="SSLCCertificate" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="SSLCCertificate"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.SSLCCertificate ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.SSLCCertificate)} target="_blank">
                                                    {' '}
                                                    <img
                                                        src="/Images/SSLCCertificate.png"
                                                        className="document-width"
                                                        alt="Document-image"
                                                    />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">SSLC Certificate</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="SSLCCertificate"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="SSLCCertificate"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        {message.SSLCCertificate ? (
                                            <label className="hive-form-mandatory">{message.SSLCCertificate}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        {documentData.HSCCertificate ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">HSC Certificate</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="HSCCertificate" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="HSCCertificate"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.HSCCertificate ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.HSCCertificate)} target="_blank">
                                                    {' '}
                                                    <img src="/Images/HSCCertificate.png" className="document-width" alt="Document-image" />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">HSC Certificate</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="HSCCertificate"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="HSCCertificate"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        {message.HSCCertificate ? (
                                            <label className="hive-form-mandatory">{message.HSCCertificate}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        {documentData.UGMarksheet ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">UG Marksheet</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="UGMarksheet" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="UGMarksheet"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.UGMarksheet ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.UGMarksheet)} target="_blank">
                                                    {' '}
                                                    <img src="/Images/UGMarkSheet.png" className="document-width" alt="Document-image" />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">UG Marksheet</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="UGMarksheet"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="UGMarksheet"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        {message.UGMarksheet ? <label className="hive-form-mandatory">{message.UGMarksheet}</label> : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        {documentData.VaccinationCertificate ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">Vaccination Certificate</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label
                                                                    htmlFor="VaccinationCertificate"
                                                                    className="profile-custom-file-upload"
                                                                >
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="VaccinationCertificate"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.VaccinationCertificate ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.VaccinationCertificate)} target="_blank">
                                                    {' '}
                                                    <img
                                                        src="/Images/VaccinationCertificate.png"
                                                        className="document-width"
                                                        alt="Document-image"
                                                    />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">Vaccination Certificate</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="VaccinationCertificate"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="VaccinationCertificate"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        {message.VaccinationCertificate ? (
                                            <label className="hive-form-mandatory">{message.VaccinationCertificate}</label>
                                        ) : null}
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        {documentData.Visa ? null : (
                                            <div className="card profile-card">
                                                <div className="card-body">
                                                    <div className="profile-spacing">
                                                        <h5 className="card-title profile-card-title mt-2">Visa</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div className="profile-upload-btn">
                                                                <label htmlFor="Visa" className="profile-custom-file-upload">
                                                                    <img
                                                                        className="me-2"
                                                                        src="/Images/profile-upload-icon.svg"
                                                                        alt="Upload Icon"
                                                                    />
                                                                    Upload
                                                                </label>
                                                                <input
                                                                    id="Visa"
                                                                    className="profile-file-upload"
                                                                    type="file"
                                                                    onChange={(e) => upload(e)}
                                                                />
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {documentData.Visa ? (
                                            <div className="card" style={{ width: '21rem' }}>
                                                <a href={DOMPurify.sanitize(documentData.Visa)} target="_blank">
                                                    {' '}
                                                    <img src="/Images/Visa.png" className="document-width" alt="Document-image" />
                                                </a>
                                                <div className="card-body hive-profile-footer-bg">
                                                    <div className="d-flex justify-content-between">
                                                        <h5 className="card-title bold-text font-16">Visa</h5>
                                                        {empid == sessionData.login_id ||
                                                            sessionData.role == 'Hr Manager' ||
                                                            sessionData.role == 'Hr' ? (
                                                            <div>
                                                                <button
                                                                    type="button "
                                                                    className="btn p-0 align-top shadow-none"
                                                                    data-bs-toggle="dropdown"
                                                                    aria-expanded="false"
                                                                >
                                                                    <img src="/Images/kebab-menu.svg" />
                                                                </button>
                                                                <ul
                                                                    className="dropdown-menu dropdown-menu-end border-0 shadow-sm hive-kebab-dropdown"
                                                                    style={{}}
                                                                >
                                                                    {/* <li htmlFor="Votd"><a className="dropdown-item dditems semibold-text font-12 " ><span><img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                <input id="Votd" className="profile-file-upload" type="file" onClick={(e) => upload(e)} /></span>Reupload
                                                            </a></li> */}

                                                                    <li>
                                                                        <label
                                                                            for="Visa"
                                                                            className="dropdown-item dditems semibold-text font-12 "
                                                                        >
                                                                            <img className="pe-2" src="/Images/hive-edit-icon.svg" />
                                                                            Reupload
                                                                        </label>
                                                                        <input
                                                                            id="Visa"
                                                                            type="file"
                                                                            className="profile-file-upload"
                                                                            onChange={(e) => upload(e)}
                                                                        />
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}
                                        {message.Visa ? <label className="hive-form-mandatory">{message.Visa}</label> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="Failure-PopUp pop-bg" hidden={deletePopUp == true ? true : false}>
                <div className="modal-dialog goal-popup modal-dialog-centered">
                    <div className="modal-content px-5">
                        <div className="modal-body text-center px-5 py-4">
                            <p className="bold-text font-18 text-blue my-5">Are you sure do you want to delete the Skill? </p>

                            <div className="text-center d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="btn hive-btn-secondary bold-text font-14 me-3"
                                    onClick={() => cancelClickedDelete()}
                                >
                                    No
                                </button>

                                <button className="btn hive-btn-primary bold-text font-14" type="submit" onClick={() => yesClicked()}>
                                    Yes Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* PC_P_43 the Below functions are called to show into the model popup mode */}
            <AddressDetail
                empId={empid}
                Mode={mode}
                Type={addresstype}
                IsAddrClick={isAddressClick}
                getEmployeeAddressGrid={() => getEmployeeAddressGrid()}
                setISAddressClick={() => setISAddressClick()}
                hideAddressForm={hideAddressForm}
                setHideAddressForm={() => setHideAddressForm()}
                showToast={(headerMessage, bodyMessage) => showToast(headerMessage, bodyMessage)}
            />
            <BankDetails
                empId={empid}
                Mode={mode}
                Id={bankId}
                IsBankClick={isBankClicked}
                getEmployeeBankGrid={() => getEmployeeBankGrid()}
                setIsBankClicked={() => setIsBankClicked()}
                showToast={(headerMessage, bodyMessage) => showToast(headerMessage, bodyMessage)}
            />
            <EducationDetail
                empId={empid}
                Mode={mode}
                Id={educationId}
                IsEducationClick={isEducationClicked}
                getEmployeeEducationGrid={() => getEmployeeEducationGrid()}
                setIsEducationClicked={() => setIsEducationClicked()}
                showToast={(headerMessage, bodyMessage) => showToast(headerMessage, bodyMessage)}
            />
            <CertificateDetails
                empId={empid}
                Mode={mode}
                Id={certificateId}
                IsCertificateClicked={isCertificateClicked}
                getEmployeeCertificateGrid={() => getEmployeeCertificateGrid()}
                setIsCertificateClicked={() => setIsCertificateClicked()}
                showToast={(headerMessage, bodyMessage) => showToast(headerMessage, bodyMessage)}
            />
            <PassportDetail
                empId={empid}
                Mode={mode}
                Id={passportId}
                IsPassportClicked={isPassportClicked}
                getEmployeePassportGrid={() => getEmployeePassportGrid()}
                setIsPassportClicked={() => setIsPassportClicked()}
                getEmployeeVisaGrid={() => getEmployeeVisaGrid()}
                passportCount={passportArrLen}
                EditSection={section}
                showToast={(headerMessage, bodyMessage) => showToast(headerMessage, bodyMessage)}
            />
            <PreviousEmploymentDetails
                empId={empid}
                Mode={mode}
                Id={previousEmpId}
                IsPreEmployClicked={isPreEmployClicked}
                getEmployeePreviousEmploymentGrid={() => getEmployeePreviousEmploymentGrid()}
                setIsPreEmployClicked={() => setIsPreEmployClicked()}
                showToast={(headerMessage, bodyMessage) => showToast(headerMessage, bodyMessage)}
            />
            <SkillDetails
                empId={empid}
                IsSkillClick={isSkillClicked}
                getEmployeeSkills={() => getEmployeeSkills()}
                setIsSkillClicked={() => setIsSkillClicked()}
                showToast={(headerMessage, bodyMessage) => showToast(headerMessage, bodyMessage)}
            />
        </>
    );
}

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(Profile);
